export const ChevronLeftIcon = () => {
  return (
    <svg
      width="40"
      height="32"
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5287 11.5288C21.789 11.2684 22.2111 11.2684 22.4714 11.5288C22.7318 11.7891 22.7318 12.2111 22.4714 12.4715L18.9428 16.0001L22.4714 19.5288L22.517 19.5795C22.7305 19.8414 22.7155 20.2274 22.4714 20.4715C22.2273 20.7155 21.8413 20.7306 21.5795 20.517L21.5287 20.4715L17.5287 16.4715C17.2683 16.2111 17.2683 15.7891 17.5287 15.5288L21.5287 11.5288Z"
        fill="white"
      />
    </svg>
  );
};
